import Request from '../../../../src/core/gd/data/request'

export default class ApiAttendance {

    static getAttendance(date: string, userId: ID) {
        return new Request(this, 'GET', 'attendance/event?date={0}&userId={1}'.f(date, userId))
    }

    static createClockIn(payload: any){

        return new Request(this, 'POST', 'attendance/clock-in', {
            userId: payload.userId,
            date: payload.date,
            type: payload.type,
            comment: payload.comment,
            deviceInfo: payload.deviceInfo ? payload.deviceInfo : null,
            officeId: payload.officeId
        })
    }

    static createClockOut(payload: any){

        return new Request(this, 'POST', 'attendance/clock-out', {
            userId: payload.userId,
            date: payload.date,
            type: payload.type,
            comment: payload.comment,
            deviceInfo: payload.deviceInfo ? payload.deviceInfo : null,
            officeId: payload.officeId
        })
    }

    static addAttendance(payload: any){

        return new Request(this, 'POST', 'attendance/event', payload)
    }

    static deleteAttendance(id: ID){
        return new Request(this, 'DELETE', 'attendance/event/' + id)
    }

    static editAttendance(id: ID, payload: any){
        return new Request(this, 'PUT', 'attendance/event/' + id, payload)
    }

    static getCurrentStatus(date: string){
        return new Request(this, 'GET', "attendance/status?date={0}".f(date))
    }


    //Reports

    static createReport(params: any){

        return new Request(this, 'POST', 'attendance/report', params)
    }


}
